import { useState, useCallback } from 'react';

// Small, self-contained "you haven't opened this yet" badge for the
// newsletter menu-bar icon. Everything it needs — the localStorage key,
// the read/write, and the exposed state — lives in this one file, so
// removing the badge later is just: delete this file, delete the
// ".newsletter-unclicked-badge" rule in NewsletterSignup.css, and remove
// the handful of lines in NewsletterSignup.js that reference it (each
// marked with a "newsletter badge" comment).

const STORAGE_KEY = 'twojakes:newsletter-icon-clicked';

function readHasClicked() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // Storage unavailable (private browsing, disabled, etc.) — default to
    // "not clicked yet" so the badge still shows rather than silently
    // never appearing.
    return false;
  }
}

function writeHasClicked() {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Best-effort; nothing to do if storage isn't available.
  }
}

// Returns [showBadge, dismissBadge]. showBadge is true until this device
// has ever dismissed it; dismissBadge both hides it immediately and
// persists that so it stays gone on future visits.
export function useNewsletterIconBadge() {
  const [showBadge, setShowBadge] = useState(() => !readHasClicked());

  const dismissBadge = useCallback(() => {
    writeHasClicked();
    setShowBadge(false);
  }, []);

  return [showBadge, dismissBadge];
}
